// 선택한 날짜를 한국 시간 그대로 'YYYY-MM-DD' 문자열로 변환
// (toISOString()은 UTC로 바꾸면서 하루 전 날짜가 되는 문제가 있음)
export const toLocalDateString = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
